// Vendor Libs
import React from 'react';
import PropTypes from 'prop-types';

// Components
import Button from '../core/button';
import Icon from '../core/icon';
import MoviesAndProgramsForNetworkDisplayPath from '../search-data/movies-and-programs-for-network-display-path';

// Styles
import './ams-program-select-overlay.scss';

function AmsProgramSelect({label, onReset, setEchoId}) {
    const mapButtonOnClick = (echoId) => {
        setEchoId(echoId);
        onReset();
    };

    return (
        <div className="ams-program-select--overlay">
            <Button className="ams-program-select--close" type="link" onClick={onReset}>
                <Icon fontType="fa" iconName="close" />
            </Button>
            <div className="ams-program-select--label">{label}</div>
            <MoviesAndProgramsForNetworkDisplayPath mapButtonOnClick={mapButtonOnClick} />
        </div>
    );
}

AmsProgramSelect.propTypes = {
    label: PropTypes.string,
    onReset: PropTypes.func,
    setEchoId: PropTypes.func,
};

export default AmsProgramSelect;
